import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Box, Button, Divider, TextField } from '@mui/material'

import OrderSearchTable from './OrderSearchTable'

export default function OrderSearchForm() {
  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      companyName: '',
      destination: '',
      orderStartDate: '',
      orderEndDate: '',
      dueDate: ''
    }
  })

  const onSubmit = (data) => {
    console.log('Search values:', data)
    // API call here
  }

  const handleReset = () => {
    reset()
  }

  return (
    <Box>
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 2,
          p: 3,
          bgcolor: '#f7faff',
          borderRadius: 2
        }}
      >
        <Controller
          name='companyName'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label='Company Name'
              placeholder='Enter company name'
              variant='outlined'
              fullWidth
            />
          )}
        />

        <Controller
          name='destination'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label='Destination'
              placeholder='Enter destination'
              variant='outlined'
              fullWidth
            />
          )}
        />

        <Controller
          name='orderStartDate'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              type='date'
              label='Order Start Date'
              InputLabelProps={{ shrink: true }}
              variant='outlined'
              fullWidth
            />
          )}
        />

        <Controller
          name='orderEndDate'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              type='date'
              label='Order End Date'
              InputLabelProps={{ shrink: true }}
              variant='outlined'
              fullWidth
            />
          )}
        />

        <Controller
          name='dueDate'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              type='date'
              label='Due Date'
              InputLabelProps={{ shrink: true }}
              variant='outlined'
              fullWidth
            />
          )}
        />

        <Box
          sx={{
            gridColumn: '1 / -1',
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant='outlined'
            color='secondary'
            onClick={handleReset}
            type='button'
          >
            Reset
          </Button>
          <Button variant='contained' color='primary' type='submit'>
            Search
          </Button>
        </Box>
        <Box sx={{ gridColumn: '1 / -1' }}>
          <Divider sx={{ my: 1 }} />
        </Box>
      </Box>
      <Box>
        <OrderSearchTable />
      </Box>
    </Box>
  )
}
